import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import "./AlternativeDepartureCityList.scss";
import AdvancedSelectFormik from "app/pages/.shared/form/AdvancedSelectFormik/AdvancedSelectFormik";
import { useRef } from "react";

const AlternativeDepartureCityList = ({
	cities = [],
	onMenuOpen,
	onMenuClose,
	openMenuOnFocus,
	onDepartureCityChange,
	selectedDepartureCityCode,
}) => {
	const selectRef = useRef();
	return (
		<AdvancedSelectFormik
			id="departureCity"
			name="departureCity"
			className="alternative-departure-city"
			classNamePrefix="advanced-select__select-search-engine"
			placeholder={
				<FormattedMessage id="search.engine.alternative.departure.cities.placeholder" />
			}
			noOptionsMessage={() => (
				<FormattedMessage id="search.engine.alternative.departure.cities.no.result" />
			)}
			openMenuOnFocus={openMenuOnFocus}
			getOptionLabel={({ label }) => label}
			getOptionValue={({ code }) => code}
			blurInputOnSelect={true}
			onChange={event => {
				onDepartureCityChange(event);
			}}
			selectRef={selectRef}
			value={
				cities.find(({ code }) => {
					return code === selectedDepartureCityCode;
				}) || ""
			}
			onMenuOpen={onMenuOpen}
			onMenuClose={onMenuClose}
			captureMenuScroll={true}
			menuShouldBlockScroll={false}
			options={cities}
			menuPortalMargin={-8}
		/>
	);
};

AlternativeDepartureCityList.propTypes = {
	cities: PropTypes.array,
	onDepartureCityChange: PropTypes.func,
	onMenuOpen: PropTypes.func,
	openMenuOnFocus: PropTypes.bool,
	onMenuClose: PropTypes.func,
	selectedDepartureCityCode: PropTypes.string,
};

export default AlternativeDepartureCityList;
